<div ngbDropdown>
    <button 
        class="btn btn-outline-primary btn-outline-transparent-border" 
        ngbDropdownToggle
        [disabled]="disabled"><small>Sort By:</small> {{sortOption.name}}{{sortOption.direction == 'desc' ? ' (desc)':''}}</button>
    <div ngbDropdownMenu>
      <button ngbDropdownItem *ngFor="let name of items" (click)="onSelectSort(name)">{{name}}{{name == sortOption.name ? (sortOption.direction == 'desc' ? ' (asc)' : ' (desc)') : ''}}</button>
    </div>
</div>